import React, { Fragment, useEffect, useState } from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import MailIcon from "@mui/icons-material/Mail";
import { useDispatch, useSelector } from "react-redux";
import Link from "hooks/Link";

import useNavigate from "hooks/Navigate";
import apis from "services";
import { Paid } from "@mui/icons-material";
import AdminNewSidebar from "components/admin/AdminNewSidebar";
import imageUrl from "utils/imageUrl";
import { Header } from "components";
import { useTranslation } from "react-i18next";
import utils from "../../utils";
import {
  ADMIN_TYPES,
  SUB_ADMIN_TYPES,
  TOTAL_SHARES,
} from "../../assets/constants";
import { setAdmin } from "redux/slices/adminSlice";
import { getToken } from "firebase/messaging";
import { firebaseApp, messaging } from "../../firebase";
import {
  AvailableShareDashboard,
  EmployeeShareDashboard,
  FundedStoreDashboard,
  ProfitDashboard,
  ShareDashboard,
  SharePerPriceDashboard,
  StoreDashboard,
  TotalInvestorDashboard,
  UserDashboard,
} from "components/SVG/SIDEBARSVG";
import { Tooltip } from "@mui/material";

export const mainListItems = (
  <Fragment>
    <Link to={"/admin/dashboard"} style={{ textDecoration: "none" }}>
      <ListItemButton
        // autoFocus={true}
        className="justify-content-center mt-3 active"
      >
        <ListItemIcon>
          <DashboardIcon sx={{ color: "#fff" }} />
        </ListItemIcon>
        <ListItemText className="text-white" primary="Dashboard" />
      </ListItemButton>
    </Link>

    <Link to={"/admin/users"} style={{ textDecoration: "none" }}>
      <ListItemButton className="justify-content-center mt-3">
        <ListItemIcon>
          <PeopleIcon sx={{ color: "#fff" }} />
        </ListItemIcon>
        <ListItemText className="text-white" primary="Users" />
      </ListItemButton>
    </Link>

    <Link to={"/admin/stores"} style={{ textDecoration: "none" }}>
      <ListItemButton className="justify-content-center mt-3">
        <ListItemIcon sx={{ color: "#fff" }}>
          <MailIcon />
        </ListItemIcon>
        <ListItemText className="text-white" primary="Stores" />
      </ListItemButton>
    </Link>

    <Link to={"/admin/transactions"} style={{ textDecoration: "none" }}>
      <ListItemButton className="justify-content-center mt-3">
        <ListItemIcon sx={{ color: "#fff" }}>
          <Paid />
        </ListItemIcon>
        <ListItemText className="text-white" primary="Transactions" />
      </ListItemButton>
    </Link>
  </Fragment>
);

const mdTheme = createTheme();

const AdminDashboard = () => {
  const adminData = useSelector((store) => store.admin);
  const admin = adminData?.adminUser;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { adminUser } = useSelector((store) => store.admin);
  const [recordData, setRecordData] = useState({ users: "", stores: "" });
  const [loading, setLoading] = useState(false);

  //Charts Api
  // const [charData, setChartData] = useState();

  const [showDropdown, setShowDropdown] = useState(false);
  const [adminStats, setAdminStats] = useState({});
  const totalInvestmentYesterday = adminStats?.totalInvestmentYesterday || 0;
  const totalInvestmentOverall = adminStats?.totalInvestmentOverall || 0;
  const fetchChartData = async () => {
    setLoading(true);
    try {
      const res = await apis.getChartData();
      if (res?.data) {
        // setChartData(res?.data?.yearly_data);
        setRecordData(res?.data?.data);
      }
    } finally {
      setLoading(false);
    }
  };

  //Analytic
  const [data, setData] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await apis.getTotalRecord();
      if (res?.data) {
        setData(res?.data);
      }
    } finally {
      setLoading(false);
    }
  };
  const fetchAdminProfile = async () => {
    setLoading(true);
    try {
      const response = await apis.getAdminProfile(admin?._id);
      if (response?.data?.status) {
        dispatch(setAdmin(response?.data?.admin));
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchToken = async () => {
    if (navigator.userAgent.indexOf("Chrome") != -1) {
      return getToken(messaging, {
        vapidKey:
          // 'BMpVypoBuKIlz3lr5Mal3KlJY2ozYfIGPBS1Hy0wwLYCh4a-XaVx0uRhKj0-a7YBtSO--qZyAQgiLWg62avaM1k'
          "BEi5L-bkWNbgKBKL3KBiymjzMl1q_rIzhKpl2IhRI8nwE5SMFH2kmx1fXgPSbopXuEZi-7Z804u3s33FVO9EyTY",
      })
        .then(async (currentToken) => {
          if (currentToken) {
            console.log("current token for client: ", currentToken);
            localStorage.setItem("not_token", currentToken);
            if (adminUser) {
              const res = await apis.updateAdminProfileToken(adminUser?._id, {
                not_token: currentToken,
              });
              if (res?.data?.status) {
                dispatch(setAdmin(res?.data?.admin));
              }
            }
          } else {
            console.log(
              "No registration token available. Request permission to generate one."
            );
          }
        })
        .catch((err) => {
          console.log("An error occurred while retrieving token. ", err);
        });
    }
  };
  const fetchAdminData = async () => {
    setLoading(true);
    try {
      const res = await apis.getAdminStats();
      if (res?.data) {
        setAdminStats(res?.data?.data);
        console.log("adminStatsApi", res?.data?.data)
        // setData(res?.data);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      await fetchData();
      await fetchAdminData();
      await fetchChartData();
      await fetchAdminProfile();
      if (navigator.userAgent.indexOf("Chrome") != -1) {
        await fetchToken();
      }
      setLoading(false);
    })();
  }, []);

  console.log("loadertrtrtt", loading);
  return (
    <ThemeProvider theme={mdTheme}>
      <Box className="dashboard-main">
        <AdminNewSidebar />
        <div className="dashboard-section-main">
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              height: "100vh",
              overflow: "auto",
            }}
            className="custom-scroll"
          >
            <Header
              showDropdown={showDropdown}
              setShowDropdown={setShowDropdown}
            />
            {loading ? (
              <div className="loader-container">
                <div className="loader" />
              </div>
            ) : (
              <Container sx={{ mt: 0, mb: 4, maxWidth: "none !important" }}>
                {/* <h3 className="dashboard-title">{t("titles.dashboard")}</h3> */}

                <Grid container className="mt-4 pt-1 db-container">
                  <div
                    className="custom-box row"
                    style={{ position: "relative" }}
                  >
                    {utils.checkAdminType() === ADMIN_TYPES.ADMIN ? (
                      <>
                        {/* USER BOX */}
                        <Tooltip title="Click to view total users" arrow>


                          <Grid item xs={12} sm={6} md={6} lg={4}>
                            <Link to='/admin/users' >
                              <Paper className="dashboard-box ">
                                <div className="text">
                                  <h3 className="">
                                    {t("labels.admin_dashboard_1")}
                                  </h3>
                                  <h4 className="">{adminStats?.totalUsers || 0}</h4>
                                  <h6
                                    className=""
                                  // onClick={() => {
                                  //   navigate("/admin/users");
                                  // }}
                                  >
                                    Report
                                  </h6>
                                </div>

                                <div className="img-con">
                                  {/* <img src={imageUrl("d_users.png")} /> */}
                                  <UserDashboard />
                                </div>
                              </Paper>
                            </Link>
                          </Grid>
                        </Tooltip>
                        <Tooltip title="Total amount raised yesterday" arrow>
                          <Grid item xs={12} sm={6} md={6} lg={4}>
                            <Paper className="dashboard-box">
                              <div className="text">
                                <h3 className="">Total amount raised yesterday</h3>
                                <h4 className="">{Number(data?.totalAmountRaisedYesterday || 0).toFixed(3)}</h4>
                              </div>

                              <div className="img-con">
                                <ProfitDashboard />
                              </div>
                            </Paper>
                          </Grid>
                        </Tooltip>
                        <Tooltip title="Total amount raised overall" arrow>
                          <Grid item xs={12} sm={6} md={6} lg={4}>
                            <Paper className="dashboard-box">
                              <div className="text">
                                <h3 className="">Total amount raised overall</h3>
                                <h4 className="">{Number(data?.totalAmountRaisedOverAll || 0).toFixed(3)}</h4>
                              </div>

                              <div className="img-con">
                                <FundedStoreDashboard />
                              </div>
                            </Paper>
                          </Grid>
                        </Tooltip>
                        {/* TOTAL SHARES BOX */}
                        <Tooltip title="Click to view admin donated shares history" arrow>
                          <Grid item xs={12} sm={6} md={6} lg={4}>
                            <Link to='/admin/share-transfer-history' >

                              <Paper className="dashboard-box">
                                <div className="text">
                                  <h3 className="">Total Donated Shares</h3>
                                  <h6 className="">
                                    {adminStats?.totalAdminDonatedShares || 0}
                                  </h6>

                                  <h6
                                  >
                                    Donation
                                  </h6>
                                </div>

                                <div className="img-con">
                                  <ShareDashboard />
                                </div>
                                {/* <img src={imageUrl("d_shares.png")} /> */}
                              </Paper>
                            </Link>
                          </Grid>
                        </Tooltip>
                        {/*"TOTAL AVAILABLE SHARES"*/}
                        <Tooltip title="Total available shares" arrow>
                          <Grid item xs={12} sm={6} md={6} lg={4}>
                            <Paper className="dashboard-box">
                              <div className="text">
                                <h3 className="">
                                  {t("labels.admin_dashboard_3")}
                                </h3>
                                <h4 className="">
                                  {Number(adminStats?.totalAvailableShares || 0).toFixed(3)}
                                </h4>
                              </div>
                              <div className="img-con">
                                {/* <img src={imageUrl("d_available_shares.png")} /> */}
                                <AvailableShareDashboard />
                              </div>
                            </Paper>
                          </Grid>
                        </Tooltip>
                        <Tooltip title="Click to view all users withdrawals amount" arrow>
                          <Grid item xs={12} sm={6} md={6} lg={4}>
                            <Link to='/admin/withDrawl' >

                              <Paper className="dashboard-box">
                                <div className="text">
                                  <h3 className="">
                                    Total Withdrawals
                                  </h3>
                                  <h6 className="">
                                    {adminStats?.totalUsersWithdrawalAmount || 0}
                                  </h6>
                                  <h6

                                  >
                                    Report
                                  </h6>
                                </div>


                                <div className="img-con">
                                  <EmployeeShareDashboard />
                                </div>
                              </Paper>
                            </Link>
                          </Grid>
                        </Tooltip>
                        <Tooltip title="Click to view all stores" arrow>
                          <Grid item xs={12} sm={6} md={6} lg={4}>
                            <Link to='/admin/stores' >

                              <Paper className="dashboard-box">
                                <div className="text">
                                  <h3 className="">
                                    {t("labels.admin_dashboard_4")}
                                  </h3>
                                  <h4 className="">{adminStats?.totalStores || 0}</h4>
                                  <h6
                                    className=""
                                  >
                                    Report
                                  </h6>
                                </div>

                                <div className="img-con">
                                  <StoreDashboard />
                                </div>
                                {/* <img src={imageUrl("d_stores.png")} /> */}
                              </Paper>
                            </Link>
                          </Grid>
                        </Tooltip>
                        <Tooltip title="Click to view all transactions" arrow>
                          <Grid item xs={12} sm={6} md={6} lg={4}>
                            <Link to='/admin/transactions' >

                              <Paper className="dashboard-box">
                                <div className="text">
                                  <h3 className="">Total Funded Store Amount</h3>
                                  <h4 className="">
                                    {Number(adminStats?.totalFundedStores || 0).toFixed(3)}
                                  </h4>

                                  <h6
                                  >
                                    Report
                                  </h6>
                                </div>

                                {/* <img src={imageUrl("d_profit.png")} /> */}
                                <div className="img-con">
                                  <FundedStoreDashboard />
                                </div>
                              </Paper>
                            </Link>
                          </Grid>
                        </Tooltip>
                        <Tooltip title="Click to view share price history" arrow>
                          <Grid item xs={12} sm={6} md={6} lg={4}>
                            <Link to='/admin/share-price-history' >

                              <Paper className="dashboard-box">
                                <div className="text">
                                  <h3 className="">Share Per Price</h3>
                                  <h4 className="">
                                    {adminStats?.currentSharePrice || 0}
                                  </h4>
                                </div>
                                <div className="img-con">
                                  {/* <img src={imageUrl("d_profit.png")} /> */}
                                  <SharePerPriceDashboard />
                                </div>
                              </Paper>
                            </Link>
                          </Grid>
                        </Tooltip>
                        <Tooltip title="Click to view total investors" arrow>
                          <Grid item xs={12} sm={6} md={6} lg={4}>
                            <Link to='/admin/users' >

                              <Paper className="dashboard-box">
                                <div className="text">
                                  <h3 className="">Total Investor</h3>
                                  <h4 className="">{adminStats?.investorsTotal || 0}</h4>
                                  <h6
                                    className=""
                                    onClick={() => {
                                      navigate("/admin/users");
                                    }}
                                  >
                                    Report
                                  </h6>
                                </div>

                                {/* <img src={imageUrl("d_users.png")} /> */}
                                <div className="img-con">
                                  <TotalInvestorDashboard />
                                </div>
                              </Paper>
                            </Link>
                          </Grid>
                        </Tooltip>
                        {/* <Grid item xs={12} sm={6} md={6} lg={4}>
                          <Paper className="dashboard-box">
                            <div className="text">
                              <h3 className="">
                                {t("labels.admin_dashboard_5")}
                              </h3>
                              <h4 className="">
                                {admin?.wallet?.dividend || 0}
                              </h4>

                              <h6
                                className=""
                                onClick={() => {
                                  navigate("/admin/transactions");
                                }}
                              >
                                Report
                              </h6>
                            </div>

                            {/* <img src={imageUrl("d_profit.png")} /> */}
                        {/* <div className="img-con">
                              <ProfitDashboard />
                            </div>
                          </Paper> */}
                        {/* // </Grid> */}
                      </>
                    ) : (
                      <></>
                    )}
                    {SUB_ADMIN_TYPES.includes(adminUser?.type) && (
                      <>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                          <Paper className="dashboard-box">
                            <div className="text">
                              <h3 className="">
                                {t("labels.admin_dashboard_1")}
                              </h3>
                              <h4 className="">{recordData?.users}</h4>
                            </div>

                            <h6
                              className="mt-5"
                              onClick={() => {
                                navigate("/sub-admin/users");
                              }}
                            >
                              Report
                            </h6>
                            <div className="img-con">
                              {/* <img src={imageUrl("d_users.png")} /> */}
                              <UserDashboard />
                            </div>
                            {/* <img src={imageUrl("d_users.png")} /> */}
                          </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                          <Paper className="dashboard-box">
                            <div className="text">
                              <h3 className="">
                                {t("labels.admin_dashboard_4")}
                              </h3>
                              <h4 className="">{recordData?.stores || 0}</h4>
                            </div>

                            <h6
                              className="mt-5"
                              onClick={() => {
                                navigate("/sub-admin/stores");
                              }}
                            >
                              Report
                            </h6>

                            <div className="img-con">
                              <StoreDashboard />
                            </div>
                          </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                          <Paper className="dashboard-box">
                            <div className="text">
                              <h3 className="">Total Funded Store Amount</h3>
                              <h4 className="">
                                {data?.totalStoreFundedAmount || 0}
                              </h4>
                            </div>

                            <h6
                              className="mt-5"
                            // onClick={() => {
                            //   navigate("/sub-admin/transactions");
                            // }}
                            >
                              Report
                            </h6>

                            <div className="img-con">
                              <FundedStoreDashboard />
                            </div>
                          </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                          <Paper className="dashboard-box">
                            <div className="text">
                              <h3 className="">
                                {t("labels.admin_dashboard_3")}
                              </h3>
                              <h4 className="">
                                {data?.totalAvailableShares || 0}
                              </h4>
                            </div>

                            {/* <img src={imageUrl("d_available_shares.png")} /> */}
                            <div className="img-con">
                              {/* <img src={imageUrl("d_available_shares.png")} /> */}
                              <AvailableShareDashboard />
                            </div>
                          </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                          <Paper className="dashboard-box">
                            <div className="text">
                              <h3 className="">Share Per Price</h3>
                              <h4 className="">
                                {data?.TOTAL_PRICE_PER_SHARE || 20}
                              </h4>
                            </div>

                            {/* <img src={imageUrl("d_profit.png")} /> */}
                            <div className="img-con">
                              {/* <img src={imageUrl("d_profit.png")} /> */}
                              <SharePerPriceDashboard />
                            </div>
                          </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                          <Paper className="dashboard-box">
                            <div className="text">
                              <h3 className="">Total Investor</h3>
                              <h4 className="">{data?.totalInvestor || 0}</h4>
                            </div>
                            <h6
                              className="mt-5"
                              onClick={() => {
                                navigate("/sub-admin/users");
                              }}
                            >
                              Report
                            </h6>

                            {/* <img src={imageUrl("d_users.png")} /> */}
                            <div className="img-con">
                              <TotalInvestorDashboard />
                            </div>
                          </Paper>
                        </Grid>
                        {/* <Grid item xs={12} sm={6} md={4} lg={3}>
                          <Paper className="dashboard-box">
                            <div className="text">
                              <h3 className="">
                                {t("labels.admin_dashboard_5")}
                              </h3>
                              <h4 className="">
                                {adminUser?.wallet?.dividend || 0}
                              </h4>
                            </div>
                            <div className="img-con">
                              <ProfitDashboard />
                            </div>
                          </Paper>
                        </Grid> */}
                      </>
                    )}

                    <img
                      src="/assets/images/frameCardBG.png"
                      alt="frameCardBG"
                      style={{
                        position: "absolute",
                        bottom: "-42px",
                        left: "-12px",
                        width: "296px",
                      }}
                    />
                  </div>

                  {/* Chart */}
                  <Grid item xs={12} md={12} lg={12} className="db-chart">
                    <Paper>
                      <div className="mt-5">
                        {/* <DashboardChart data={charData} /> */}
                      </div>
                    </Paper>
                  </Grid>
                </Grid>
              </Container>
            )}
          </Box>
        </div>
      </Box>
    </ThemeProvider>
  );
};

export default AdminDashboard;
